import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { NotesViewPageStore } from "@/store/pages/NotesViewPageStore/NotesViewPageStore";
import { action, observable } from "mobx";
import { makeObservable } from "mobx";
import { createRef, RefObject } from "react";

export class FindInNoteStore {
  readonly notesViewPageStore: NotesViewPageStore;

  isOpen = false;
  searchQuery = "";
  currentMatchIndex = -1;
  matchesCount = 0;
  anchorRef: RefObject<HTMLButtonElement> = createRef();

  constructor(notesViewPageStore: NotesViewPageStore) {
    this.notesViewPageStore = notesViewPageStore;

    makeObservable(this, {
      notesViewPageStore: false,
      useEffects: false,

      anchorRef: observable,
      isOpen: observable,
      searchQuery: observable,
      currentMatchIndex: observable,
      matchesCount: observable,
      open: action,
      close: action,
      setSearchQuery: action,
      setSearchResults: action,
      findNext: action,
      findPrevious: action,
    });
  }

  open = () => {
    this.isOpen = true;
  };

  close = () => {
    this.isOpen = false;
    this.searchQuery = "";
    this.currentMatchIndex = 0;
    this.matchesCount = 0;
  };

  setSearchQuery = (searchQuery: string) => {
    if (searchQuery === this.searchQuery) return;

    this.searchQuery = searchQuery;
    this.currentMatchIndex = -1;
    this.matchesCount = 0;
  };

  setSearchResults = ({
    matchesCount,
    currentMatchIndex,
  }: {
    matchesCount: number;
    currentMatchIndex: number;
  }) => {
    this.matchesCount = matchesCount;
    this.currentMatchIndex = currentMatchIndex;
  };

  findNext = () => {
    if (this.matchesCount === 0) return;
    this.currentMatchIndex = (this.currentMatchIndex + 1) % this.matchesCount;
  };

  findPrevious = () => {
    if (this.matchesCount === 0) return;
    this.currentMatchIndex = Math.abs(
      (this.currentMatchIndex - 1 + this.matchesCount) % this.matchesCount
    );
  };

  useEffects = () => {
    useEffectOnMount(() => {
      return () => this.close();
    });
  };
}
